import type { ArceusMascotSize } from './types';

/**
 * Asset paths for the 3D Arceus mascot. The files under public/arceus-3d/mascot/ are copied verbatim from
 * the opsManager app (public/arceus-3d/mascot/, see its README.md for the rig and texture notes).
 */

/** The meshopt-compressed GLB (loads its sibling arceus-mascot.jpg / arceus-mascot-front.jpg textures). */
export const ARCEUS_MASCOT_GLB = '/arceus-3d/mascot/arceus-mascot.glb';
/** The canonical art's outline (alpha): the 3D body is cut to it, so his silhouette is the painting's. */
export const ARCEUS_MASCOT_MASK = '/arceus-3d/mascot/arceus-mascot-mask.png';

/** Still posters rendered from the same GLB (idle pose, t=0), so the poster -> 3D cross-fade has no jump. */
export const ARCEUS_MASCOT_POSTER: Record<ArceusMascotSize, string> = {
  sm: '/arceus-3d/mascot/poster-sm.webp',
  md: '/arceus-3d/mascot/poster-md.webp',
};

/** Intrinsic poster pixel sizes (sips on the source files): md 768x1056, sm 192x192. */
export const ARCEUS_MASCOT_POSTER_SIZE: Record<ArceusMascotSize, { width: number; height: number }> = {
  sm: { width: 192, height: 192 },
  md: { width: 768, height: 1056 },
};

/** Kill switch: REACT_APP_ARCEUS_3D=off keeps the still poster everywhere (build-time, CRA inlines it). */
export const ARCEUS_3D_ENABLED = process.env.REACT_APP_ARCEUS_3D !== 'off';
